export default [
    {
        path: "/e-bidding/expressions-of-interest",
        name: "expressions-of-interest",
        meta: {
            title: "Expressions of Interest",
            authRequired: true,
            privileges: ['SUPPLIER_VIEW_TENDERS']
        },
        component: () => import("../views/e-bidding/expressions-of-interest"),
    },
    {
        path: "/e-bidding/view-expression-of-interest/:id",
        name: "view-expression-of-interest",
        meta: {
            title: "View Expression of Interest",
            authRequired: true,
            privileges: ['SUPPLIER_VIEW_TENDER_DETAILS']
        },
        component: () => import("../views/e-bidding/eoi-view.vue"),
    },
    {
        path: "/e-bidding/expressions-of-interest-bids",
        name: "expressions-of-interest-bids",
        meta: {
            title: "Expressions of Interest Bids",
            authRequired: true,
            privileges: ['SUPPLIER_VIEW_TENDERS']
        },
        component: () => import("../views/e-bidding/expressions-of-interest-bids.vue"),
    },
    {
        path: "/e-bidding/respond-to-expression-of-interest/:id?/:eoiId?",
        name: "respond-to-expression-of-interest",
        meta: {
            title: "Respond to Expression of Interest",
            authRequired: true,
            privileges: ['SUPPLIER_EXPRESS_INTEREST']
        },
        component: () => import("../views/e-bidding/eoi-response.vue"),
    },
]
